
import * as SubActionConstant from "../../constants/SubActionConstant";
import { OtsAircraft } from "../../Models/OtsAircraft";
import { EditOtsData } from "../../Models/EditOtsData";

const eventChangeTitleTemplate = "Event type changed from {prevEventType} to {fleetType}";
const placeholderClassNameTitle = 'PLACEHOLDER_CLASS_NAME_TITLE';
const placeholderClassNameValue = 'PLACEHOLDER_CLASS_NAME_VALUE';

export const findSubAction = (otsEventData: OtsAircraft, editedOtsEvent: EditOtsData) => {
        const subActions = [];
        if (editedOtsEvent.station !== otsEventData?.Station) {
            subActions.push(SubActionConstant.STATION);
        }
        if (editedOtsEvent.location !== otsEventData?.Location) {
            subActions.push(SubActionConstant.LOCATION);
        }
        if (editedOtsEvent.ataCode !== otsEventData?.ATACode?.toString()) {
            subActions.push(SubActionConstant.ATA);
        }
        if (
            editedOtsEvent.advtime?.toISOString() !==
            (otsEventData?.AdviseTimeUTC
                ? new Date(otsEventData?.AdviseTimeUTC).toISOString()
                : undefined)
        ) {
            subActions.push(SubActionConstant.ADV);
        }
        if (
            editedOtsEvent.etrtime?.toISOString() !==
            (otsEventData?.EstimatedReturnToServiceTimeUTC
                ? new Date(otsEventData?.EstimatedReturnToServiceTimeUTC).toISOString()
                : undefined)
        ) {
            subActions.push(SubActionConstant.ETR);
        }
        if (
            editedOtsEvent.otstime?.toISOString() !==
            (otsEventData?.OutOfServiceDateTimeUTC
                ? new Date(otsEventData?.OutOfServiceDateTimeUTC).toISOString()
                : undefined)
        ) {
            subActions.push(SubActionConstant.OTS_START_TIME);
        }
        if (editedOtsEvent.problemText !== otsEventData?.ProblemText) {
            subActions.push(SubActionConstant.PROBLEM_TEXT);
        }
        return subActions.join(",");
}

export const isAirborneEvent = (inboundFlight?: InboundFlight) => { 

    if (inboundFlight && inboundFlight.Flight && inboundFlight.Flight.ActualOnTimeUTC === null) {
        return true; 
    }

    return false;
}

export const deriveMessageTitle = (subAction: string, updatedOtsEvent: UpdatedOtsEvent, prevOtsEvent: OtsAircraft) => {
    let title = "";
    let advEtrUpdated = false;

           if (subAction) {
               const singleSubAction = subAction.split(",");
               if (subAction == SubActionConstant.OTS_RETURN_TO_SERVICE) {
                   title += "Event closed";
               } else if (singleSubAction[0] == SubActionConstant.OTS_REOPEN) {
                   title += "Event reopened";
               } else {
                   for (let updatedAction of singleSubAction) { 
                       if (updatedAction == SubActionConstant.STATION) {
                           title += deriveHtmlCodedTitle("Station updated", updatedOtsEvent.station, prevOtsEvent.Station);
                       }
                       else if (updatedAction == SubActionConstant.LOCATION) {
                           title += deriveHtmlCodedTitle("Loc updated", updatedOtsEvent.location, prevOtsEvent.Location);
                       }
                       else if (updatedAction == SubActionConstant.PROBLEM_TEXT) {
                           title += deriveHtmlCodedTitle("Problem statement updated", updatedOtsEvent.problemText, prevOtsEvent.ProblemText);
                       }
                       else if (updatedAction == SubActionConstant.ADV || updatedAction == SubActionConstant.ETR && !advEtrUpdated) {
                            if(subAction.includes(SubActionConstant.ADV) && subAction.includes(SubActionConstant.ETR)){
                                //Both changed
                                if(updatedOtsEvent.adviseTimeUTC && !updatedOtsEvent.estimatedReturnToServiceTimeUTC){
                                    //ETR to ADV
                                    title += deriveHtmlCodedTitle("ETR/ADV updated", updatedOtsEvent.adviseTimeUTC || "", prevOtsEvent.EstimatedReturnToServiceTimeUTC || "", true, { from: "ETR: ", to: "ADV: " });
                                }
                                else if(!updatedOtsEvent.adviseTimeUTC && updatedOtsEvent.estimatedReturnToServiceTimeUTC){
                                    //ADV to ETR
                                    title += deriveHtmlCodedTitle("ETR/ADV updated", updatedOtsEvent.estimatedReturnToServiceTimeUTC || "", prevOtsEvent.AdviseTimeUTC || "", true, { from: "ADV: ", to: "ETR: " });    
                                }
                            }
                            else if(subAction.includes(SubActionConstant.ADV)){
                                //Only ADV changed
                                title += deriveHtmlCodedTitle("ETR/ADV updated", updatedOtsEvent.adviseTimeUTC || "", prevOtsEvent.AdviseTimeUTC || "", true, { from: "ADV: ", to: "ADV: " });
                            }
                            else if(subAction.includes(SubActionConstant.ETR)){
                                //Only ETR changed
                                title += deriveHtmlCodedTitle("ETR/ADV updated", updatedOtsEvent.estimatedReturnToServiceTimeUTC || "", prevOtsEvent.EstimatedReturnToServiceTimeUTC || "", true, { from: "ETR: ", to: "ETR: " });
                            }
                            advEtrUpdated = true;
                       }
                       else if (updatedAction == SubActionConstant.ATA) {
                           title += deriveHtmlCodedTitle("ATA updated", updatedOtsEvent.ATACode, prevOtsEvent.ATACode);
                       }
                       else if (updatedAction == SubActionConstant.OTS_START_TIME) {
                           title += deriveHtmlCodedTitle("OTS start time updated", updatedOtsEvent.outOfServiceDateTimeUTC || "", prevOtsEvent.OutOfServiceDateTimeUTC, true);
                       }
                       else if (updatedAction == SubActionConstant.OTS_RETURN_TO_SERVICE_EDIT) {
                           title += deriveHtmlCodedTitle("OTS closed time updated", updatedOtsEvent.returnToServiceTimeUTC || "", prevOtsEvent.ReturnToServiceTimeUTC || "", true);
                       }
                       else if (updatedAction == SubActionConstant.EVENT_TYPE_CHANGE){
                            const prevEventType = prevOtsEvent.EventTypeTo || prevOtsEvent.EventType;
                            const updatedEventType = updatedOtsEvent.eventTypeTo || updatedOtsEvent.eventType;
                            title += deriveHtmlCodedTitle("Event type updated", updatedEventType, prevEventType);
                       }
                   }
               }
           }
           return title;
}

export const deriveHtmlCodedTitle = (title: string, updatedValue: string, prevValue: string, isTimestamp: boolean = false, advEtrChange : { from: string, to: string } = { from: "", to: "" }) => {
  let htmlStructure = `<div class="${placeholderClassNameTitle}">${title}`;
  if (prevValue) {
    const prevValueHtml = isTimestamp 
      ? `<div class="${placeholderClassNameValue}"><del>${advEtrChange.from}<span data-timestamp="${prevValue}"></span></del></div>` 
      : `<div class="${placeholderClassNameValue}"><del>${prevValue}</del></div>`;
    htmlStructure += prevValueHtml;
  }
  if (updatedValue) {
    const updatedValueHtml = isTimestamp
    ? `<div class="${placeholderClassNameValue}">${advEtrChange.to}<span data-timestamp="${updatedValue}"></span></div>` 
    : `<div class="${placeholderClassNameValue}">${updatedValue}</div>`;
    htmlStructure += updatedValueHtml;
  }
  htmlStructure += `</div>`;
  return htmlStructure;
}

export const deriveProblemStatementHistory = (updatedOtsEvent: any, problemTextChanges: any) => {
     if (updatedOtsEvent.subAction.includes(SubActionConstant.PROBLEM_TEXT) &&
      problemTextChanges
    ) {
      let historyString = "";

      problemTextChanges.forEach((change: any) => {
        if (change.ProblemText) {
          historyString += `<div><del>${change.ProblemText}</del></div>`;
        }
      });

      if (updatedOtsEvent.problemText) {
        historyString += `<div>${updatedOtsEvent.problemText}</div>`;
      }

      return historyString;
    }
  };

  export const deriveSubActionForEventChange = (isAirborne: boolean, existingOtsData: OtsAircraft, fleetEventType: string) => {
    const eventType = isAirborne ? existingOtsData.EventTypeTo : existingOtsData.EventType;
    if (eventType !== fleetEventType) {
        return SubActionConstant.EVENT_TYPE_CHANGE + ",";
    }
    else
        return "";
  } 
